<template>
  <div class="image-upload">
    <div
      v-if="imagePreview"
      v-loading="uploading"
      class="image-upload__preview"
      :style="imageStyle"
    >
      <template v-if="!imageUrl">
        <img
          v-if="imageThumbnail"
          :src="imageThumbnail"
          :alt="'Image'"
          :class="imageType"
        />
        <img
          v-else
          :src="getImage('empty/image.svg')"
          :alt="'Image'"
          :class="'default'"
        />
      </template>
      <img v-else :src="imageUrl" :alt="'Image'" :class="imageType" />
    </div>
    <el-upload
      action=""
      :on-change="setImage"
      :show-file-list="false"
      :auto-upload="false"
      accept="image/*"
    >
      <slot>
        <a :style="style"
          >{{ imageUrl || imageThumbnail ? "Change" : "Upload" }}
          {{ imageText }}</a
        >
      </slot>
    </el-upload>
  </div>
</template>

<script>
export default {
  name: "RaImageUpload",
  props: {
    imageUrl: {
      type: String,
      default: ""
    },
    imagePreview: {
      type: Boolean,
      default: true
    },
    imageSize: {
      type: Number,
      default: 80
    },
    imageType: {
      type: String,
      default: "rounded"
    },
    imageText: {
      type: String,
      default: "image"
    },
    imageFit: {
      type: String,
      default: "contain"
    }
  },
  data() {
    return {
      types: {
        square: "0px",
        rounded: "12px",
        circle: "1000px"
      },
      style: {
        fontWeight: "500",
        fontSize: "0.875rem"
      },
      imageThumbnail: "",
      uploading: false
    };
  },
  computed: {
    imageStyle() {
      return {
        height: `${this.imageSize}px`,
        width: `${this.imageSize}px`,
        borderRadius: this.types[this.imageType]
      };
    }
  },
  methods: {
    setImage(event) {
      if (event.raw) {
        if (event.size / 1024 / 1024 < 1) {
          this.uploading = true;

          const reader = new FileReader();
          reader.onload = e => {
            this.imageThumbnail = e.target.result;
          };
          reader.readAsDataURL(event.raw);

          this.$emit("selected", event.raw);

          setTimeout(() => {
            this.uploading = false;
          }, 1000);
        } else {
          this.$notify({
            message: "Image size cannot be more than 1MB",
            customClass: "danger"
          });
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
.image-upload {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  &__preview {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80px;
    width: 80px;
    border-radius: 16px;
    background: #eef0f5;
    margin-bottom: 10px;

    img {
      height: 100%;
      width: 100%;
      object-fit: contain;

      &.default {
        height: auto;
        width: 50%;
        margin: auto 0;
      }

      &.rounded {
        border-radius: 12px;
      }
    }

    + div {
      width: 100%;
      max-width: 80px;
    }
  }

  a {
    color: var(--ra-red-primary);
    font-size: 0.75rem !important;
  }
}
</style>
